/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { hmsAPI } from '@/api'

export const postFeedback = data => hmsAPI.put('/feedback', data)
export const deleteFeedback = imageId => hmsAPI.delete(`/feedback/${imageId}`)
